jQuery( function( $ ) {
	$( document ).ready( function() {
		const video = $( '.hero-video' );

		if ( 0 < video.length ) {
			heroVideo( video );
		}
	} );
} );

function heroVideo( video ) {
	let url1 = video.data( 'url1' );
	let url2 = video.data( 'url2' );
	const width = window.innerWidth;
	const height = window.innerHeight;

	// Fallback if video field is not set.
	if ( ! url2 ) {
		url2 = url1;
	}

	if ( ! url1 ) {
		url1 = url2;
	}

	if ( 0 < video.length ) {
		if ( 0.66 > width / height ) {
			video.append( '<source src=' + url1 + " type='video/mp4' >" );
		} else {
			video.append( '<source src=' + url2 + " type='video/mp4' >" );
		}
	}
}
